import React, { useContext } from 'react'
import { Route, Routes } from 'react-router-dom'

import { AbilityContext } from '../../components/Ability'
import OrderCreate from './Features/OrderCreate'
import OrderQuickCreate from './Features/OrderQuickCreate'
import OrderListPage from './Features/OrderList'
import OrderDetailPage from './Features/OrderDetail'
import NotFound from '../NotFound'
import OrderListTeleSalePage from './Features/OrderListTeleSale'
import OrderImportExcelPage from './Features/OrderImportExcel'
import OrderQuickCreateOld from './Features/OrderQuickCreateOld'
import OrderPlatformListPage from './Features/OrderPlatformList'

const OrdersPage = () => {
  const ability = useContext(AbilityContext)

  return (
    <Routes>
      <Route
        path="/telesale"
        element={
          ability.can('manage', 'Order', 'telesaleOrder') ? (
            <OrderListTeleSalePage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/create"
        element={
          ability.can('manage', 'CreateOrder', 'createOrder') ? (
            <OrderCreate />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/quick-create"
        element={
          ability.can('manage', 'CreateOrder', 'quickOrder') ? (
            <OrderQuickCreate />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/quick-create-old"
        element={
          ability.can('manage', 'CreateOrder', 'quickOrderV1') ? (
            <OrderQuickCreateOld />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/detail/:id"
        element={
          ability.can('manage', 'Order') ? <OrderDetailPage /> : <NotFound />
        }
      />
      <Route
        path="/import-excel"
        element={
          ability.can('manage', 'CreateOrder', 'importExcel') ? (
            <OrderImportExcelPage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route path="/platform/:platform" element={<OrderPlatformListPage />} />
      <Route path="/:status" element={<OrderListPage />} />
      <Route path="/" element={<OrderListPage />} />
    </Routes>
  )
}

export default OrdersPage
